import { render, staticRenderFns } from "./product-purchase-listing-container.vue?vue&type=template&id=52eb6d87&scoped=true&lang=pug"
import script from "./product-purchase-listing-container.js?vue&type=script&lang=js&external"
export * from "./product-purchase-listing-container.js?vue&type=script&lang=js&external"
import style0 from "./product-purchase-listing-container.vue?vue&type=style&index=0&id=52eb6d87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52eb6d87",
  null
  
)

export default component.exports